"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var hasStateChange = function (action) {
    return Object.prototype.hasOwnProperty.call(action, 'stateChange');
};
var reducer = function (state, action) {
    if (hasStateChange(action)) {
        return __assign({}, state, action.stateChange);
    }
    return state;
};
var REDUX_DEVTOOLS_OPTIONS = {
    name: 'ReactN',
};
function createReduxEnhancedStore(globalStateManager) {
    try {
        if (process.env.NODE_ENV === 'production' ||
            typeof window !== 'object' ||
            !window.__REDUX_DEVTOOLS_EXTENSION__) {
            return null;
        }
        require.resolve('redux');
        var createStore = require('redux').createStore;
        var storeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION__(REDUX_DEVTOOLS_OPTIONS);
        var store = createStore(reducer, globalStateManager.state, storeEnhancer);
        return store;
    }
    catch (e) {
        return null;
    }
}
exports.createReduxEnhancedStore = createReduxEnhancedStore;



//////////////////
// WEBPACK FOOTER
// ./node_modules/reactn/build/utils/redux-dev-tools.js
// module id = 464
// module chunks = 0